module.exports = __webpack_public_path__ + "static/media/testobalance1.daddbb6e.png";